Shopify.money_format = "£{{amount}}";